import { render, staticRenderFns } from "./SupplierHeader.vue?vue&type=template&id=22e597bd"
import script from "./SupplierHeader.vue?vue&type=script&lang=js"
export * from "./SupplierHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports